import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { getAuthToken } from "../utils/utils"

interface LoginRestrictProps {
  children: React.ReactNode
}

const LoginRestrict: React.FC<LoginRestrictProps> = ({ children }) => {
  const navigate = useNavigate()

  useEffect(() => {
    const token = getAuthToken()
    if (token) {
      navigate("/dashboard")
    }
  }, [])

  return <>{children}</>
}

export default LoginRestrict
